import { Palettes, ShopType, Variants } from '@/types';
import { ArrowIcon, PhoneIcon } from '../Icons';
import styles from './ShopDrawerContent.module.scss';
import { Button } from '../Button';
import { BLACK, PRIMARY } from '@/constants/colors';
import cn from 'classnames';
import { SingleSlider } from '../SingleSlider';
import { SwiperSlide } from 'swiper/react';
import { useTranslations } from '@/hooks/useTranslations';
import { useClientTranslations } from '@/hooks/useClientTranslations';
import { getBackendImage } from '@/utils/getBackendImage';
import { ModalGallery } from '../ModalGallery';
import { useEffect, useState } from 'react';
import { ProductCard } from '../ProductCard';
import { fetchData as fetchDataApi } from '@/services/fetchData';
// import { Slider } from '../InteriorCard/Slider/Slider';
import { Slider, SliderVariant } from '@/components/Slider';
import { Loader } from '../Loader';

type ShopDrawerContentProps = {
  className?: string;
  data: ShopType;
  onClose: () => void;
};

type PhoneItem = {
  number: string;
};

export const ShopDrawerContent = ({
  data,
  className,
  onClose,
}: ShopDrawerContentProps) => {
  const wrapperClassName = cn(styles.wrapper, className);
  const { name, address, workTime, images, town } = data;
  const { getTranslations } = useTranslations();
  const t = useClientTranslations();
  const [galleryViewItem, setGalleryViewItem] = useState<number | null>(null);
  const [products, setProducts] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleBuildRoute = () => {
    const addressText = getTranslations(address);
    const routeUrl = `https://yandex.ru/maps/?text=${addressText}, ${getTranslations(town)}`;
    window.open(routeUrl, '_blank');
  };

  const handle2GisRoute = () => {
    const addressText = getTranslations(address);
    const twogisUrl = `https://2gis.ru/search/${addressText}, ${getTranslations(town)}`;
    window.open(twogisUrl, '_blank');
  };

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        setIsLoading(true);
        const seoRes = await fetchDataApi({
          url: `/good/list?isCount=true&page=1&shop=${data.id}&sort=popular`,
        });
        if (seoRes.success) {
          setProducts(seoRes.data.results);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error fetching SEO data:', error);
      }
    };

    fetchSeoData();
  }, []);

  const handlePrevImage = () => {
    setGalleryViewItem((prev) =>
      (prev ?? 0) === 0 ? images.length - 1 : (prev ?? 0) - 1,
    );
  };

  const handleNextImage = () => {
    setGalleryViewItem((prev) =>
      (prev ?? 0) === images.length - 1 ? 0 : (prev ?? 0) + 1,
    );
  };

  return (
    <div className={wrapperClassName}>
      <div className={styles.heading}>
        <ArrowIcon className={styles.back} color={BLACK} onClick={onClose} />
        <div className={styles.text}>
          <span className={styles.name}>{getTranslations(name)}</span>
          <span className={styles.address}>{getTranslations(address)}</span>
        </div>
      </div>
      <div className={styles.maps}>
        <div className={styles.title}>{t.shopDrawerContent.buildRoute}</div>
        <div className={styles.buttons}>
          <Button
            palette={Palettes.Transparent}
            text="Яндекс.Карты"
            onClick={handleBuildRoute}
            variant={Variants.Outline}
          />
          <Button
            palette={Palettes.Transparent}
            text="2ГИС"
            onClick={handle2GisRoute}
            variant={Variants.Outline}
          />
        </div>
      </div>
      <div className={styles.contacts}>
        {data.phones.map((item: PhoneItem) => (
          <a
            href={`tel:${item.number.replace(/\s/g, '')}`}
            className={styles.phone}
            key={item.number}
          >
            <PhoneIcon color={PRIMARY} size={20} />
            <span className={styles.phoneNumber}>{item.number}</span>
          </a>
        ))}
        <div className={styles.mode}>
          <span className={styles.time}>{getTranslations(workTime)}</span>
        </div>
      </div>
      <SingleSlider className={styles.gallerySlider}>
        {images.map((item, index) => (
          <SwiperSlide key={index}>
            <div className={styles.galleryWrapper}>
              <img
                src={getBackendImage(item)}
                alt="shop"
                className={styles.gallery}
                loading="lazy"
                onClick={() => setGalleryViewItem(index)}
              />
            </div>
          </SwiperSlide>
        ))}
      </SingleSlider>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={styles.productsSliderWrapper}>
          <p className={styles.products}>Товары в магазине</p>
          <Slider variant={SliderVariant.Pagination}>
            {products.map((good: any, index: number) => (
              <SwiperSlide className="swiper-slide-custom" key={index}>
                <ProductCard good={good} hot={false} />
              </SwiperSlide>
            ))}
          </Slider>
        </div>
      )}
      <ModalGallery
        galleryViewItem={galleryViewItem}
        setGalleryViewItem={setGalleryViewItem}
        gallery={images}
        handlePrevImage={handlePrevImage}
        handleNextImage={handleNextImage}
      />
    </div>
  );
};
